module.exports = __webpack_public_path__ + "img/hc_pro_two_1.0fd8304f.jpg";